import { useEffect } from 'react';
import { useLayout } from '@/contexts/LayoutContext';
import { useTheme } from '@/contexts/ThemeContext';
import { layout4ThemeStyle } from './theme';

const WL4_THEME_KEYS = [
  '--wl4-accent',
  '--wl4-primary',
  '--wl4-secondary',
  '--wl4-header-bg',
  '--wl4-menu',
  '--wl4-title',
  '--wl4-text',
  '--wl4-dark',
  '--wl4-topbar-bg',
  '--wl4-topbar-text',
  '--wl4-footer-bg',
  '--l4-accent',
] as const;

/** Injeta variáveis WL4 no :root quando o layout 4 está ativo (sheet/menu em portal). */
export function Layout4ThemeSync() {
  const { currentLayout } = useLayout();
  const { colors } = useTheme();

  useEffect(() => {
    const root = document.documentElement;
    const isLayout4 = currentLayout === 'layout-4';

    if (!isLayout4) {
      WL4_THEME_KEYS.forEach((key) => root.style.removeProperty(key));
      return;
    }

    const style = layout4ThemeStyle(colors);
    Object.entries(style).forEach(([key, value]) => {
      if (typeof value === 'string') {
        root.style.setProperty(key, value);
      }
    });

    return () => {
      WL4_THEME_KEYS.forEach((key) => root.style.removeProperty(key));
    };
  }, [currentLayout, colors]);

  return null;
}
